import React, { useState } from 'react';

import {
  FlexWrapper,
  OptionButtonWrapper,
  OptionsListContainer,
  QuizCardsContainer
} from './OptionsList.styled';
import { utils } from 'kb-shared';
import HelpText from 'screens/Book/components/HelpText';

import { CategoryCard } from './CategoryCard';
import { QuizOptionCard } from './QuizOptionCard';
import { BookingQuizAnswer } from '../BookingQuiz.types';
import { CATEGORY_ICONS } from '../BookingQuizIcons';

interface Props {
  options: Array<BookingQuizAnswer>;
  large: boolean;
  onSelect: (opt: BookingQuizAnswer) => void;
  isLoggedIn: boolean | undefined;
}

const parseQuizText = (text: string): string => {
  // Remove parentheses and content inside them
  return text.replace(/\s*\([^)]*\)/g, '').trim();
};

export const OptionsList = ({ options, large, onSelect, isLoggedIn }: Props): React.JSX.Element => {
  const [selectedOptionId, setSelectedOptionId] = useState<string | null>(null);

  return (
    <OptionsListContainer data-testid="service-options-container">
      {large ? (
        <FlexWrapper>
          {options.map((opt: BookingQuizAnswer) => (
            <OptionButtonWrapper key={opt.text} $large>
              <CategoryCard
                label={opt.text}
                icon={
                  opt.category && CATEGORY_ICONS[opt.category]
                    ? CATEGORY_ICONS[opt.category]
                    : undefined
                }
                onClick={() => onSelect(opt)}
              />
            </OptionButtonWrapper>
          ))}
        </FlexWrapper>
      ) : (
        <QuizCardsContainer>
          {options.map((opt: BookingQuizAnswer) => {
            const mainText = parseQuizText(opt.text);
            return (
              <QuizOptionCard
                key={opt.id}
                mainText={mainText}
                selected={selectedOptionId === opt.id}
                onClick={() => {
                  setSelectedOptionId(opt.id);
                  onSelect(opt);
                }}
              />
            );
          })}
        </QuizCardsContainer>
      )}
      {!isLoggedIn && (
        <HelpText
          text="Not sure which option?"
          linkText="Contact us"
          linkUrl={`mailto:${utils.KBContacts.navigatorEmail}?subject=Appointment Booking Question`}
        />
      )}
    </OptionsListContainer>
  );
};
